import { useParams } from 'next/navigation';

import { useSession } from '~hooks/useSession';
import { botsApi } from '~services/api/bots';

export const useGetContacts = (options?: {
	skip?: boolean;
	pollingInterval?: number;
}) => {
	const { userId } = useSession();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();

	const {
		isLoading: isContactsLoading,
		isSuccess: isContactsSuccess,
		isFetching: isContactsFetching,
		isError: isContactsError,
		data,
		...rest
	} = botsApi.useGetContactsQuery(
		{ userId },
		{ skip: !userId || options?.skip, ...options }
	);

	const profileSkip =
		!recipientId || !isContactsSuccess || !!data?.contacts[recipientId];

	const {
		isLoading: isProfileLoading,
		isSuccess: isProfileSuccess,
		isFetching: isProfileFetching,
		isError: isProfileError,
	} = botsApi.useGetBotProfileQuery(
		{ userId, recipientId },
		{ skip: !userId || profileSkip }
	);

	const isSuccess = isContactsSuccess && (isProfileSuccess || profileSkip);

	return {
		isLoading: isContactsLoading || isProfileLoading,
		isSuccess,
		isFetching: isContactsFetching || isProfileFetching,
		isError: isContactsError || isProfileError,
		data,
		...rest,
	};
};
